import { DataSourceType as t, PermutiveServiceProvider as o, SalesforceProductType as c } from "@decentriq/graphql/dist/enums";
import { ImportDatasetInputSchema as n } from "@decentriq/graphql/dist/validation";
import { t as i } from "../../../../zod.BGwKDjoR.js";
import { m as r } from "../../../../lodash.DGoHQECz.js";
import { z as m } from "../../../../zod.BRvRcVQy.js";
const d = n(), a = {
  datasetName: ""
}, l = (s) => {
  switch (s) {
    case t.S3:
      return r({}, a, {
        s3: {
          credentials: {
            accessKey: "",
            secretKey: ""
          },
          sourceConfig: {
            bucket: "",
            objectKey: "",
            region: ""
          }
        }
      });
    case t.Salesforce:
      return r({}, a, {
        salesforce: {
          apiName: "",
          credentials: {
            clientId: "",
            clientSecret: ""
          },
          domainUrl: "",
          productType: c.Core
        }
      });
    case t.Permutive:
      return r({}, a, {
        permutive: {
          configuration: {
            gcs: {
              bucketName: ""
            }
          },
          credentials: {
            gcs: {
              credentials: ""
            }
          },
          datasets: {
            demographicsDatasetName: "",
            matchingDatasetName: "",
            segmentsDatasetName: ""
          },
          serviceProvider: o.GoogleCloudStorage
        }
      });
    case t.GoogleCloudStorage:
      return r({}, a, {
        gcs: {
          bucketName: "",
          credentials: "",
          objectName: ""
        }
      });
    case t.Azure:
      return r({}, a, {
        azure: {
          credentials: {
            blobName: "",
            sasToken: "",
            storageAccount: "",
            storageContainer: ""
          }
        }
      });
    case t.Snowflake:
      return r({}, a, {
        snowflake: {
          credentials: {
            accountId: "",
            password: "",
            role: "",
            username: ""
          },
          sourceConfig: {
            databaseName: "",
            schemaName: "",
            stageName: "",
            tableName: "",
            warehouseName: ""
          }
        }
      });
    default:
      return a;
  }
}, S = (s) => i(
  /*
    NOTE: `schema` has to be adjusted in runtime since `syncType` isn't known in advance.
    First marking `datasetName` as optional, to be calculated with `transform` immediately after.
  */
  d.merge(m.object({
    datasetName: m.string().optional()
  })).transform((e) => {
    switch (s) {
      case t.S3:
        return {
          ...e,
          datasetName: e?.datasetName?.trim() || e?.s3?.sourceConfig?.objectKey?.trim()
        };
      case t.Azure:
        return {
          ...e,
          datasetName: e?.datasetName?.trim() || e?.azure?.credentials?.blobName?.trim()
        };
      case t.GoogleCloudStorage:
        return {
          ...e,
          datasetName: e?.datasetName?.trim() || e?.gcs?.objectName?.trim()
        };
      case t.Salesforce:
        return {
          ...e,
          datasetName: e?.datasetName?.trim() || ""
        };
      case t.Permutive:
        return {
          ...e,
          datasetName: [e?.permutive?.datasets?.matchingDatasetName?.trim() ?? "", e?.permutive?.datasets?.segmentsDatasetName?.trim() ?? "", e?.permutive?.datasets?.demographicsDatasetName?.trim() ?? ""].join(" & ")
        };
      case t.Snowflake:
        return {
          ...e,
          datasetName: e?.datasetName?.trim() || e?.snowflake?.sourceConfig?.tableName?.trim()
        };
      default:
        return e;
    }
  })
);
export {
  a as defaultValues,
  l as getDefaultValuesBySyncType,
  S as getResolverBySyncType,
  d as schema
};
//# sourceMappingURL=model.js.map
